export default __webpack_public_path__ + "static/media/ico_modal.7d6a39c0.svg";